import React from 'react';
import EventOptionsFormContainer from '../../../../Containers/AdminContainer/EventOptions/EventOptionsForm';
const EventOptionsFormScreen = () => {
  return <EventOptionsFormContainer />;
};

export default EventOptionsFormScreen;
